import { render } from "./footerview.vue?vue&type=template&id=63e09d11&scoped=true"
import script from "./footerview.vue?vue&type=script&lang=js"
export * from "./footerview.vue?vue&type=script&lang=js"

import "./footerview.vue?vue&type=style&index=0&id=63e09d11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e09d11"]])

export default __exports__